"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=department.invite.legacy.js.map